export default __webpack_public_path__ + "static/media/img-no-config@1x.56a498d8.png";